export default __webpack_public_path__ + "static/illustration-card-four.url-1ef50c315c33d8ba597d0313b0145217.svg";